import { render } from "./MenuActivity.vue?vue&type=template&id=5b9e9ba6"
import script from "./MenuActivity.vue?vue&type=script&lang=js"
export * from "./MenuActivity.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__